import SettingsPage from "@/pages/SettingsPage";
import { Navigate, Route, BrowserRouter as Router, Routes } from "react-router-dom";
import AuthGuard from "./components/auth/AuthGuard";
import ProtectedRoute from "./components/ProtectedRoute";
import APIProvider from "./contexts/APIContext";
import { NotificationProvider } from "./contexts/NotificationContext";
import { OnboardingProvider } from "./contexts/OnboardingContext";
import AppointmentsPage from "./pages/AppointmentsPage";
import BookingPage from "./pages/BookingPage";
import ChatPage from "./pages/ChatPage";
import ChatsPage from "./pages/ChatsPage";
import LandingPage from "./pages/LandingPage";
import Login from "./pages/Login";
import Onboarding from "./pages/Onboarding";
import OnboardingComplete from "./pages/OnboardingComplete";
import ProfilePage, { ProfileRedirect } from "./pages/ProfilePage";
import SearchPage from "./pages/SearchPage";

function App() {
  return (
    <Router>
      <APIProvider>
        <OnboardingProvider>
          <AuthGuard>
            <NotificationProvider>
              <div className="min-h-screen bg-gray-50">
                <Routes>
                  {/* Public routes */}
                  <Route path="/features" element={<LandingPage />} />
                  <Route path="/login" element={<Login />} />
                  <Route path="/" element={<Navigate to="/dashboard" />} />
                  <Route path="/dashboard" element={<SearchPage />} />
                  <Route path="/profile/:userId" element={<ProfilePage />} />

                  {/* Protected routes */}
                  <Route element={<ProtectedRoute />}>
                    <Route path="/onboarding" element={<Onboarding />} />
                    <Route path="/onboarding-complete" element={<OnboardingComplete />} />
                    <Route path="/profile" element={<ProfileRedirect />} />
                    <Route path="/booking/:userId/:slotId" element={<BookingPage />} />
                    <Route path="/settings" element={<SettingsPage />} />
                    <Route path="/appointments" element={<AppointmentsPage />} />
                    <Route path="/chats" element={<ChatsPage />} />
                    <Route path="/chat/:userId" element={<ChatPage />} />
                    {/* Add more protected routes here */}
                  </Route>

                  {/* Catch all for unknown routes */}
                  <Route path="*" element={<LandingPage />} />
                </Routes>
              </div>
            </NotificationProvider>
          </AuthGuard>
        </OnboardingProvider>
      </APIProvider>
    </Router>
  );
}

export default App;
